import React, { useEffect, useState, useContext } from 'react';
import { View, KeyboardAvoidingView, StyleSheet, Text, TextInput, Keyboard, FlatList, Platform } from 'react-native';
// import Screen from '../components/Screen';
// import UploadScreen from './UploadScreen';
// import * as Progress from "react-native-progress";
import colors from '../config/colors';
import { MaterialCommunityIcons } from "@expo/vector-icons";
import defaultStyles from "../config/styles";
import dateNow from '../utility/dateNow';
//import useAuth from '../auth/useAuth';
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import {  ListItemAccount } from '../components/lists';
import ActivityIndicator from '../components/ActivityIndicator';
//import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import createNotification from '../utility/createNotification';
import AuthContext from '../auth/context';




function CommentsSeedScreen({ route, navigation }) {
    //const [progress, setProgress] = useState(0) // para que es 
    const [uploadVisible, setUploadVisible] = useState(false);
    const [items, setItems] = useState([]) // Es para jalar el item---
    const [commentBoxText, setCommentBoxText] = useState('') // para que jale el comentario 
    const [loading, setLoading] = useState(false);
    const { user, setUser } = useContext(AuthContext);
    //const { user } = useAuth();
    var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
    var numComments = 0
    var date = dateNow()
    useEffect(() => {
        date = dateNow()
        if (Platform.OS == 'ios') {
            Keyboard.addListener('keyboardDidShow', () => {
                console.log('entre keyboardDidShow (:')
                setUploadVisible(true)
            })
            Keyboard.addListener('keyboardDidHide', () => {
                console.log('entre keyboardDidHide ):')
                setUploadVisible(false)
            })
        }
        // setUploadVisible(true)
        // setProgress(0.3)
        getComments()
        //debugger
    }, [])

    //---------------------------------------------------------------------------------------
    //Agrega un comentario a una seed. 1 *Función inicio de la encadenación de servicios.
    //---------------------------------------------------------------------------------------
    const uploadComment = async () => {
        //debugger

        var seedId = route.params.item.seedId
        var post_values = {
            seedId: seedId,    //: route.params.seedId, 
            userIdSeedPublisherComment: JSON.parse(user).userId,
            dateComment: date,
            commentSeedBox: commentBoxText,
            origin: route.params.item.origin,
            type: route.params.item.type
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/insertCommentSeeds/', configurationPost)
            .then(response => response.json())
            .then(response => {
                setCommentBoxText('')
                setLoading(true)
                var userId = JSON.parse(user).userId
                var descripNotification = JSON.parse(user).userName + ' comentó tu semilla'
                var notificationTypeId = 4
                createNotification.insertNotification(descripNotification, seedId, userId, notificationTypeId)
                getNumComments()
            })
            .catch(err => {
                console.log(':( review internet service /insertCommentSeeds/', err)
            })
    }

    //----------------------------------------------------------
    // Traer la cuenta de los comentarios de una seed 2 *
    //----------------------------------------------------------
    const getNumComments = async () => {
        //debugger
        var post_values = {
            seedId: route.params.item.seedId,
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/SelectCountSeedComments/', configurationPost)
            .then(response => response.json())
            .then(response => {
                numComments = response.data[0].total_comments
                incrementComments()
            })
            .catch(err => {
                console.log(':( review internet service /SelectCountSeedComments/', err)
            })
    }

    //-----------------------------------------------------------------------------------
    //servicio que hace un incremeto al campo de número de comments en seedComments 3 * 
    //-----------------------------------------------------------------------------------
    const incrementComments = async () => {
        //debugger
        var post_values = {
            totalSeedComments: numComments,
            seedId: route.params.item.seedId,
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/UpdateIncrementSeedComment/', configurationPost)
            .then(response => response.json())
            .then(response => {
                getComments()
            })
            .catch(err => {
                console.log('Insert fixo failed :( review internet service /UpdateIncrementSeedComment/', err)
            })
    }

    //------------------------------------------------------------------
    //Traer los comentarios de la semila 4 * Término de la encadenación
    //------------------------------------------------------------------
    const getComments = async () => {
        //debugger
        var post_values = {
            seedId: route.params.item.seedId,
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/SelectSeedComments/', configurationPost)
            .then(response => response.json())
            .then(response => {
                setItems(response.data)
                console.log('response - ', response.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(':( review internet service /SelectSeedComments/', err)
            })
    }

    return (
        <>
            {/* <Text style={styles.textGoBack} 
                onPress={() => {
                  //indexLike = index
                  //var pick = items[index].seedId
                  //navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, {pick}  );
                  navigation.goBack();
                  }                  
                } > Prueba en Comment Seeds</Text> */}
            {/* <View style={styles.container}> */}

            <FlatList
                data={items}
                keyExtractor={(items) => items.seedCommentsId.toString()}
                renderItem={({ item, index }) => (
                    <ListItemAccount
                        image={profileUri + item.userId + '_' + item.userPhoto}
                        titleRol={item.userName}
                        subTitle={item.commentSeedBox}
                        onPress={() => {
                            props.navigation.navigate(routes.FOUND_USER, { item, index })
                        }}
                    >
                    </ListItemAccount>
                )}>
            </FlatList>

            <ActivityIndicator visible={loading} />
            {uploadVisible === false ?
                <KeyboardAvoidingView
                    keyboardVerticalOffset={1}
                    behavior={Platform.OS == 'ios' ? 'floating' : 'height'}
                    style={styles.container}
                >
                    <View style={styles.containerSearch} >

                        <TextInput style={styles.input}
                            onChangeText={text => {
                                console.log('emoji text -> ', text)
                                setCommentBoxText(text)
                            }}
                            placeholder="Comment"
                            value={commentBoxText}
                        />
                        {
                            commentBoxText.trim() === '' ?
                                null
                                :
                                <MaterialCommunityIcons
                                    onPress={() => uploadComment()}
                                    name={"upload"}
                                    size={35}
                                    color={defaultStyles.colors.medium}
                                    style={styles.icon}
                                />
                        }

                    </View>
                </KeyboardAvoidingView>
                :
                <KeyboardAvoidingView
                    keyboardVerticalOffset={1}
                    behavior={Platform.OS == 'ios' ? 'padding' : 'height'}
                    style={styles.container}
                >
                    <View style={styles.containerSearchIos} >

                        <TextInput style={styles.input}
                            onChangeText={text => setCommentBoxText(text)}
                            placeholder="Comment"
                            value={commentBoxText}
                        />
                        {
                            commentBoxText.trim() === '' ?
                                null
                                :
                                <MaterialCommunityIcons
                                    onPress={() => uploadComment()}
                                    name={"upload"}
                                    size={35}
                                    color={defaultStyles.colors.medium}
                                    style={styles.icon}
                                />
                        }

                    </View>
                </KeyboardAvoidingView>
            }

            {/* </View> */}
        </>
    );
}
const styles = StyleSheet.create({
    container: {
        //flex: 1,
        //padding:"40%"
        //height: "70%",
        //flexDirection: "column",
        //alignItems: "baseline",
        //alignSelf: "baseline"
        //position: "relative",    //'absolute',
        //bottom:   "%keyboardOffset"
        // backgroundColor: colors.pistache,
    },
    containerSearch: {

        marginTop: Platform.OS == 'ios' ? '25%' : "1%",
        marginBottom: "10%",
        flexDirection: "row",
        width: "100%",
        height: 50,
        backgroundColor: colors.pistache,
        //position: "relative",    //'absolute',
        // bottom:   "%keyboardOffset"
    },
    containerSearchIos: {
        marginTop: '-38%',
        marginBottom: "10%",
        flexDirection: "row",
        width: "100%",
        height: 50,
        backgroundColor: colors.pistache,
        //position: "relative",    //'absolute',
        // bottom:   "%keyboardOffset"
    },
    containerFlatlist: {
        width: "100%"
    },
    input: {
        borderWidth: 1,
        borderColor: colors.medium,
        paddingLeft: 5,
        borderRadius: 5,
        width: "80%",
        marginLeft: "5%"
    },
    icon: {
        alignSelf: "center",
        margin: 1,
        width: "7%",
    },
    textGoBack: {
        fontSize: 22,
        color: "black",
        marginLeft: "32%",
        marginTop: "10%",
        //width: "350%",
        textAlign: "justify",
    },

})

export default CommentsSeedScreen;